import { Turbo } from '@hotwired/turbo-rails'
import { Application } from '@hotwired/stimulus'

// Turbo Drive is off by default. Pages can opt-in by setting window.enableTurboDrive = true
// in a synchronous <script> tag before this module loads (via content_for :header).
// When disabled, use data-turbo="true" on elements to enable Turbo for specific links/forms.
Turbo.session.drive = window.enableTurboDrive === true
const application = Application.start()

// Configure Stimulus development experience
application.debug = false
window.Stimulus = application

export { application }
